export const checkboxInputMixin = {
    data() {
        return {
            allItemsSelected: false
        }
    },
    methods: {
        onCheckboxInput(value, itemsObject) {
            switch (value) {
                case true:
                    let allFilled = Object.keys(itemsObject).every((k) => itemsObject[k].checked);
                    allFilled ? this.allItemsSelected = true : '';
                    break;
                case false:
                    this.allItemsSelected = false;
            }
        },
        markAll(value, itemsObject) {
            this.allItemsSelected = value;
            Object.keys(itemsObject).map(index => {
                itemsObject[index].checked = value;
            })
        }
    }
}
